import React, { useState, Fragment } from 'react';
import Accordion from 'b2b-ui-components-lib/lib/components/accordion';
import Input from 'b2b-ui-components-lib/lib/components/input';

import { numberWithCommas, monthsToYear } from 'home/view/upgrade-order/utils';

const PricingQuotationSummary = ({ orderDetail }) => {
  const [accordionMeta, setAccordionMeta] = useState({
    isExpanded: true
  });

  const contractPeriod = Math.floor(monthsToYear(orderDetail?.lead?.connectivityLineItems?.[0]?.planDetail?.planPeriod));
  const arc = orderDetail?.lead?.connectivityLineItems?.[0]?.planDetail?.price?.amount;
  const otc = orderDetail?.lead?.connectivityLineItems?.[0]?.planDetail?.price?.otc;
  const totalCost =
    orderDetail?.lead?.connectivityLineItems?.[0]?.planDetail?.price?.amount * Math.floor(monthsToYear(orderDetail?.lead?.connectivityLineItems?.[0]?.planDetail?.planPeriod)) +
    orderDetail?.lead?.connectivityLineItems?.[0]?.planDetail?.price?.otc;

  return (
    <div className="pnq-details upgrade-accordion">
      <Accordion
        autoScrollOnExpand={false}
        title={
          <React.Fragment>
            {accordionMeta.isExpanded ? (
              <div className="upgrade-header-open">
                <div className="title pad-bottom-0">Plan & Configuration</div>
                <label className="field_label">All fields are mandatory unless marked optional.</label>
              </div>
            ) : (
              <Fragment>
                <div className="upgrade-header-open">
                  <div className="title pad-bottom-0">Plan & Configuration</div>
                  <label className="field_label">The following the plan & configuration details for the new installation address.</label>
                </div>
                <ul className="upgrade-header-closed">
                  <li key="total-price">{`Total Contract Value: ₹ ${totalCost ? numberWithCommas(totalCost) : DEFAULT_MONEY}`}</li>
                  <li key="otc">{`One Time Charge: ₹ ${numberWithCommas(otc)}`}</li>
                  <li key="arc">{`Annual Recurring Charge: ₹ ${numberWithCommas(arc)}`}</li>
                  {contractPeriod && <li key="contract-period">{`Contract Period: ${contractPeriod} ${contractPeriod > 1 ? 'Years' : 'Year'}`}</li>}
                </ul>
              </Fragment>
            )}
          </React.Fragment>
        }
        isExpanded={accordionMeta.isExpanded}
        onExpandClick={() =>
          setAccordionMeta((accordionMeta) => ({
            ...accordionMeta,
            isExpanded: !accordionMeta.isExpanded
          }))
        }
        variant="round"
      >
        <div className="upgrade-body">
          <div className="plan_configration_controller">
            <div className="plan_config_details">
              <Input placeholder="" label="Contract Period" value={`${contractPeriod} ${contractPeriod > 1 ? 'Years' : 'Year'}`} required touched disabled />
              <ul className="charge_list">
                <li className="old_arc">
                  <div className="charge_name">Old Annual Recurring Charge (per year):</div>
                  <div className="charge_value">₹{numberWithCommas(orderDetail?.lead?.connectivityLineItems?.[0]?.oldLineItemDetail?.price?.rental)}</div>
                </li>
                <li>
                  <div className="charge_name">{`New Annual Recurring Charge (per year):`}</div>
                  <div className="charge_value">₹{numberWithCommas(arc)}</div>
                </li>
                <li>
                  <div className="charge_name">{`One Time Charge (Shifting Charges)`}</div>
                  <div className="charge_value">₹{numberWithCommas(otc)}</div>
                </li>
                <li className="total_inclusion">
                  <div className="charge_name">
                    <strong>Total Contract Value</strong>
                    <small>(Excluding GST rates as applicable)</small>
                  </div>
                  <div className="charge_value">₹{numberWithCommas(totalCost)}</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </Accordion>
    </div>
  );
};

export default PricingQuotationSummary;
